import { createTheme } from '@mui/material/styles';

const fontFamily = ['Nunito', 'Helvetica', 'Arial', 'sans-serif'].join(',');

export const theme = createTheme({
  typography: {
    fontFamily,
  },
  palette: {
    primary: {
      main: '#1a1a2e', // Azul marinho escuro
      dark: '#16213e',
      light: '#0f3460',
    },
    secondary: {
      main: '#f4f1de', // Creme claro
      light: '#ffffff',
      dark: '#e8e4d0',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a2e',
      secondary: '#6b7280',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '6px !important',
          height: '6px !important',
        },
        '*::-webkit-scrollbar-track': {
          background: '#f5f5f5 !important',
          margin: '10px 0 !important',
          borderRadius: '20px',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#1a1a2e !important',
          borderRadius: '20px !important',
          cursor: 'pointer !important',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#16213e !important',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          '& fieldset': {
            borderRadius: '50px',
            borderColor: '#d1d5db',
            borderWidth: '1.5px',
          },
          '&:hover fieldset': {
            borderColor: '#1a1a2e',
            borderWidth: '1.5px',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#1a1a2e',
            borderWidth: '2px',
          },
          '& input': {
            color: '#374151',
            caretColor: '#1a1a2e',
            padding: '16.5px 14px',
            '&::placeholder': {
              color: '#9ca3af',
              opacity: 1,
            },
          },
          '&.MuiInputBase-multiline': {
            padding: '16.5px 14px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          fontSize: 14,
          color: '#6b7280',
          '&.Mui-focused': {
            color: '#1a1a2e',
            fontWeight: 600,
          },
          '&.MuiFormLabel-filled': {
            color: '#374151',
          },
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '0 4px',
            borderRadius: '4px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          fontWeight: 600,
          textTransform: 'unset',
          fontSize: 16,
          boxShadow: 'none !important',
          height: '48px',
          padding: '12px 24px',
        },
        contained: {
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(26, 26, 46, 0.2) !important',
          },
        },
        text: {
          '&:hover': {
            backgroundColor: 'rgba(26, 26, 46, 0.08)',
          },
        },
      },
    },
  },
});
